// Google Analytics服务

export const GA_TRACKING_ID = 'G-34VX7GL0DF';

// 初始化Google Analytics
export function initAnalytics() {
  // 添加Google Analytics脚本
  const script1 = document.createElement('script');
  script1.async = true;
  script1.src = `https://www.googletagmanager.com/gtag/js?id=${GA_TRACKING_ID}`;
  document.head.appendChild(script1);

  // 初始化gtag函数
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  gtag('js', new Date());
  gtag('config', GA_TRACKING_ID);

  // 将gtag函数挂载到window对象，以便全局访问
  window.gtag = gtag;
}

// 页面浏览跟踪
export function trackPageView(path, title) {
  if (window.gtag) {
    window.gtag('config', GA_TRACKING_ID, {
      page_path: path,
      page_title: title
    });
  }
}

// 自定义事件跟踪
export function trackEvent(eventName, eventParams = {}) {
  if (window.gtag) {
    window.gtag('event', eventName, eventParams);
  }
}